import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 12,
    width: '40%'
  },
  sectionContainer: {
    marginTop: 25,
    display: 'grid',
    width: '100%',
    gridTemplateColumns: '5fr 1fr 5fr',
    gridGap: 12,
    height: '72vh'
  }
}))

export default useStyles
